"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/ro-RO.ts
var ro_RO_exports = {};
__export(ro_RO_exports, {
  AG_CHARTS_LOCALE_RO_RO: () => AG_CHARTS_LOCALE_RO_RO
});
module.exports = __toCommonJS(ro_RO_exports);
var AG_CHARTS_LOCALE_RO_RO = {
  ariaAnnounceChart: "diagram\u0103, ${seriesCount}[number] serii",
  ariaAnnounceFlowProportionLink: "leg\u0103tur\u0103 ${index} din ${count}, de la ${from} la ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nodul ${index} din ${count}, ${description}",
  ariaAnnounceGaugeChart: "grafic indicator, ${caption}",
  ariaAnnounceHierarchyChart: "diagram\u0103 ierarhic\u0103, ${caption}",
  ariaAnnounceHierarchyDatum: "nivel ${level}[number], ${count}[number] copii, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Ap\u0103sa\u021Bi Spa\u021Biu sau Enter pentru a comuta vizibilitatea",
  ariaLabelAddHorizontalLine: "Adaug\u0103 Linie Orizontal\u0103",
  ariaLabelAnnotationOptionsToolbar: "Op\u021Biuni adnotare",
  ariaLabelAnnotationSettingsDialog: "Set\u0103ri Anotare",
  ariaLabelColorPicker: "Selector de culoare",
  ariaLabelFinancialCharts: "Grafice financiare",
  ariaLabelLegend: "Legend\u0103",
  ariaLabelLegendItem: "${label}, Element de legend\u0103 ${index}[number] din ${count}[number]",
  ariaLabelLegendItemUnknown: "Element necunoscut din legend\u0103",
  ariaLabelLegendPageNext: "Pagina urm\u0103toare a legendei",
  ariaLabelLegendPagePrevious: "Pagina precedent\u0103 a legendei",
  ariaLabelLegendPagination: "Pagini legend\u0103",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maxim",
  ariaLabelNavigatorMinimum: "Minim",
  ariaLabelNavigatorRange: "Interval",
  ariaLabelRangesToolbar: "Intervale",
  ariaLabelSettingsTabBar: "Set\u0103ri",
  ariaLabelZoomToolbar: "Zoomare",
  ariaValuePanRange: "${min}[percent0to2dp] la ${max}[percent0to2dp]",
  contextMenuDownload: "Desc\u0103rcare",
  contextMenuPanToCursor: "Mut\u0103 vizualizarea aici",
  contextMenuToggleOtherSeries: "Comut\u0103 alte serii",
  contextMenuToggleSeriesVisibility: "Comutare Vizibilitate",
  contextMenuZoomToCursor: "Zoom la acest punct",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Dat\u0103 \u0219i Pre\u021B",
  dialogHeaderDateRange: "Interval de date",
  dialogHeaderFibonacciRange: "Retragere Fibonacci",
  dialogHeaderLine: "Linie",
  dialogHeaderPriceRange: "Interval de pre\u021B",
  dialogHeaderText: "Text",
  dialogInputAlign: "Aliniaz\u0103",
  dialogInputColorPicker: "Culoare",
  dialogInputColorPickerAltText: "Culoarea textului",
  dialogInputExtendAbove: "Extinde deasupra",
  dialogInputExtendBelow: "Extinde \xEEn jos",
  dialogInputExtendChannelEnd: "Extinde cap\u0103tul canalului",
  dialogInputExtendChannelStart: "Extinde \xEEnceputul canalului",
  dialogInputExtendLeft: "Extinde la st\xE2nga",
  dialogInputExtendLineEnd: "Extinde sf\xE2r\u0219itul liniei",
  dialogInputExtendLineStart: "Extinde \xEEnceputul liniei",
  dialogInputExtendRight: "Extinde spre dreapta",
  dialogInputFibonacciBands: "Benzi",
  dialogInputFibonacciBandsAltText: "Benzi Fibonacci",
  dialogInputFillColorPicker: "Umplere",
  dialogInputFillColorPickerAltText: "Culoare de umplere",
  dialogInputFontSize: "M\u0103rime",
  dialogInputFontSizeAltText: "M\u0103rime font",
  dialogInputLineStyle: "Linie Punctat\u0103",
  dialogInputPosition: "Pozi\u021Bie",
  dialogInputReverse: "Invers",
  dialogInputShowFill: "Afi\u0219eaz\u0103 Umplerea",
  dialogInputStrokeWidth: "Grosime",
  dialogInputStrokeWidthAltText: "Grosimea liniei",
  iconAltTextAlignCenter: "Centrat",
  iconAltTextAlignLeft: "St\xE2nga",
  iconAltTextAlignRight: "Dreapta",
  iconAltTextClose: "\xCEnchide",
  iconAltTextLineStyleDashed: "Lung-tratat",
  iconAltTextLineStyleDotted: "Linie punctat\u0103 scurt\u0103",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Jos",
  iconAltTextPositionCenter: "Centru",
  iconAltTextPositionTop: "Sus",
  inputTextareaPlaceholder: "Ad\u0103uga\u021Bi text",
  measurerDateRangeBars: "${value}[number] bare",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volumul ${value}",
  overlayLoadingData: "Se \xEEncarc\u0103 datele...",
  overlayNoData: "Nicio dat\u0103 de afi\u0219at",
  overlayNoVisibleSeries: "Nicio serie vizibil\u0103",
  overlayUnsupportedBrowser: "Versiune de browser incompatibil\u0103. V\u0103 rug\u0103m s\u0103 actualiza\u021Bi browserul.",
  seriesHistogramTooltipCount: "${yName} (num\u0103r)",
  seriesHistogramTooltipFrequency: "Frecven\u021B\u0103",
  seriesHistogramTooltipMean: "${yName} (medie)",
  seriesHistogramTooltipSum: "${yName} (suma)",
  toolbarAnnotationsArrow: "S\u0103geat\u0103",
  toolbarAnnotationsArrowDown: "S\u0103geat\u0103 \xEEn jos",
  toolbarAnnotationsArrowUp: "S\u0103geat\u0103 \xEEn sus",
  toolbarAnnotationsCallout: "Anotare",
  toolbarAnnotationsClearAll: "\u0218terge tot",
  toolbarAnnotationsComment: "Comentariu",
  toolbarAnnotationsDatePriceRange: "Dat\u0103 \u0219i Pre\u021B",
  toolbarAnnotationsDateRange: "Interval de date",
  toolbarAnnotationsDelete: "\u0218terge",
  toolbarAnnotationsDisjointChannel: "Canal separat",
  toolbarAnnotationsDragHandle: "Trage\u021Bi bara de instrumente",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retragere Fibonacci",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Bazat pe Trend",
  toolbarAnnotationsFillColor: "Culoare de umplere",
  toolbarAnnotationsHorizontalLine: "Linie orizontal\u0103",
  toolbarAnnotationsLineAnnotations: "Linii de tendin\u021B\u0103",
  toolbarAnnotationsLineColor: "Culoare Linie",
  toolbarAnnotationsLineStrokeWidth: "Grosimea Liniei",
  toolbarAnnotationsLineStyle: "Stil linie",
  toolbarAnnotationsLock: "Blocare",
  toolbarAnnotationsMeasurerAnnotations: "M\u0103sur\u0103tori",
  toolbarAnnotationsNote: "Not\u0103",
  toolbarAnnotationsParallelChannel: "Canal paralel",
  toolbarAnnotationsPriceRange: "Interval de pre\u021B",
  toolbarAnnotationsQuickDatePriceRange: "M\u0103sur\u0103",
  toolbarAnnotationsSettings: "Set\u0103ri",
  toolbarAnnotationsShapeAnnotations: "S\u0103ge\u021Bi",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Adnot\u0103ri text",
  toolbarAnnotationsTextColor: "Culoarea textului",
  toolbarAnnotationsTextSize: "Dimensiune text",
  toolbarAnnotationsTrendLine: "Linie de tendin\u021B\u0103",
  toolbarAnnotationsUnlock: "Deblocare",
  toolbarAnnotationsVerticalLine: "Linie Vertical\u0103",
  toolbarRange1Month: "1L",
  toolbarRange1MonthAria: "1 lun\u0103",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 an",
  toolbarRange3Months: "3L",
  toolbarRange3MonthsAria: "3 luni",
  toolbarRange6Months: "6L",
  toolbarRange6MonthsAria: "6 luni",
  toolbarRangeAll: "Total",
  toolbarRangeAllAria: "Toate",
  toolbarRangeYearToDate: "An p\xE2n\u0103 \xEEn prezent",
  toolbarRangeYearToDateAria: "Anul p\xE2n\u0103 \xEEn prezent",
  toolbarSeriesTypeCandles: "Lum\xE2n\u0103ri",
  toolbarSeriesTypeDropdown: "Tip de diagram\u0103",
  toolbarSeriesTypeHighLow: "High Low",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Lum\xE2n\u0103ri goale",
  toolbarSeriesTypeLine: "Linie",
  toolbarSeriesTypeLineWithMarkers: "Linie cu Marcatori",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linie \xEEn trepte",
  toolbarZoomPanEnd: "Deruleaz\u0103 p\xE2n\u0103 la sf\xE2r\u0219it",
  toolbarZoomPanLeft: "Panoramare spre st\xE2nga",
  toolbarZoomPanRight: "Panoramare la dreapta",
  toolbarZoomPanStart: "Panoramare la \xEEnceput",
  toolbarZoomReset: "Reseteaz\u0103 zoom-ul",
  toolbarZoomZoomIn: "M\u0103rire",
  toolbarZoomZoomOut: "Mic\u0219oreaz\u0103",
  tooltipPaginationStatus: "${index}[number] din ${count}[number]"
};
//# sourceMappingURL=ro-RO.cjs.js.map
